import { render, staticRenderFns } from "./AppLayout0.vue?vue&type=template&id=5ba01c13&scoped=true&"
import script from "./AppLayout0.vue?vue&type=script&lang=js&"
export * from "./AppLayout0.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout0.vue?vue&type=style&index=0&id=5ba01c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba01c13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VCol,VContainer,VIcon,VMain,VRow,VSnackbar})
